module.exports = __webpack_public_path__ + "media/andenes/retenedor_ruedas-d8f3be57.webp";